<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar> 
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <ion-title>HISTORIAL</ion-title>
          <ion-buttons v-if="eventosFinalizados.length > 0" slot="end">
            <ion-button @click="muestraAlertOrdenar();">
              <ion-icon slot="icon-only" :icon="swapVerticalOutline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-refresher slot="fixed" @ionRefresh="recargarEventosFinalizados($event);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
    
      <div v-if="eventosFinalizados.length > 0" class="my-3 mx-3">
        <ion-card  @click="muestraModalVerEvento(evento)" color="success" class="cursor-pointer" :key="index" v-for="(evento, index) in eventosFinalizados" >
          <ion-card-header>
            <ion-card-subtitle class="text-dark" >
              <div class="row">
                <div class="col">
                  <fa :icon="['fad', 'check-double']" class="mr-2" />
                  <span class="font-italic" v-text="evento.fecha_ff"></span>
                </div>
              </div>
            </ion-card-subtitle>
            <ion-card-title color="light" v-text="evento.tev_tipo"></ion-card-title>
          </ion-card-header>
        </ion-card>
      </div>

     <div v-else class="row mt-3">
        <div class="col text-center">
          Usted no tiene historial de eventos.
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonButtons, isPlatform, IonRefresher, IonRefresherContent, IonButton, IonIcon, IonMenuButton, IonCard, IonCardTitle, IonCardHeader, IonCardSubtitle, IonHeader, IonPage, IonTitle, IonToolbar, toastController, loadingController, modalController, alertController} from '@ionic/vue';
//import NuevoEvento from './NuevoEvento.vue'
//import { add } from 'ionicons/icons';
import { swapVerticalOutline}  from 'ionicons/icons';

import { defineComponent }  from 'vue';
import { Preferences     }  from '@capacitor/preferences';
import { cerrarSesion    }  from '@/plugins/funciones.ts';
import rutaBase             from '@/plugins/variables';
import axios                from 'axios';
import VerEvento            from './VerEvento.vue';

export default defineComponent({
  name: 'Pendientes',
  components: {
    IonContent, IonHeader, IonRefresher, IonRefresherContent, IonPage, IonButton, IonButtons, IonIcon, IonMenuButton, IonTitle, IonToolbar, IonCard,IonCardTitle, IonCardHeader, IonCardSubtitle
  },

  data(){
    return {
      //add, 
      swapVerticalOutline,
      cargandoTodo        :null,
      eventosFinalizados  :[],
      modalVerEvento      :null,
      esMovil             :false,
      ordenhistorial      :'fecha_desc' 
    }
  },
  mounted(){
    this.detectaPlataforma();
    this.cargandoDatosTotal();
    this.listarEventosFinalizados();
  },
  methods:{
    async cargandoDatosTotal() {
      this.cargandoTodo = await loadingController
        .create({
          cssClass: 'text-secondary',
          message: 'CARGANDO DATOS...',
          animated:false,
          mode:'md'
        });

      await this.cargandoTodo.present();
    },

    detectaPlataforma(){
      if((isPlatform('ios') || isPlatform('android') || isPlatform('mobile')) || !isPlatform('mobileweb') && !isPlatform('desktop')){
        this.esMovil = true;
      }
      else{
        this.esMovil = true;
      } 
    },

    async listarEventosFinalizados(){
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('rut_persona', parseInt(rutPersona.value));
      axios.post(rutaBase+'/normal/listarEventosFinalizados', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.eventosFinalizados = resp.data;
          this.cargandoTodo.dismiss();
        }
      }).catch(() =>{
        this.cargandoTodo.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async recargarEventosFinalizados(evento = null){
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('rut_persona', parseInt(rutPersona.value));
      axios.post(rutaBase+'/normal/listarEventosFinalizados', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.eventosFinalizados = resp.data;
          if(evento){ evento.target.complete(); }
        }
      }).catch(() =>{
        this.eventosFinalizados = [];
        if(evento){ evento.target.complete(); }
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },
    

    async muestraModalVerEvento(evento){
      this.modalVerEvento = await modalController
        .create({
          component       : VerEvento,
          //backdropDismiss : false,
          componentProps  : {
            propEvento    : evento,
            //modal         : this.modalVerEvento,
            esMovil       : this.esMovil
          }
        });
      this.modalVerEvento.present();
      const modalResponse = await this.modalVerEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandlerVE({...modalResponse.data})
    },

    async muestraAlertOrdenar() {
      let orden = this.ordenhistorial;
      const alert = await alertController
        .create({
          cssClass: 'text-justify',
          header: 'ORDENAR POR',
          inputs: [
            {
              type: 'radio',
              label: 'FECHA ASC',
              value: 'fecha_asc',
              handler: () => {
                orden = 'fecha_asc';
              },
              checked: orden == 'fecha_asc',
            },
            {
              type: 'radio',
              label: 'FECHA DESC',
              value: 'fecha_desc',
              handler: () => {
                orden = 'fecha_desc';
              },
              checked: orden == 'fecha_desc',
            },
          ],
          buttons: [
            {
              text: 'CANCELAR',
              handler: () => {
                //No se borra
              },
            },
            {
              text: 'ACEPTAR',
              handler: () => {
                this.ordenhistorial = orden;
                this.ordenarHistorial();
              },
            },
          ],
        });
      return alert.present();
    },

    ordenarHistorial(){
      let ordenH;
      if(this.ordenhistorial == 'fecha_asc') ordenH=1;
      if(this.ordenhistorial == 'fecha_desc') ordenH=-1;

      this.eventosFinalizados.sort(function (a, b) {
        const d1 = a.fecha.split("-"); const h1 = a.hora.split(":");
        const d2 = b.fecha.split("-"); const h2 = b.hora.split(":");
        const fecha1 = new Date(d1[2],d1[1],d1[0],h1[1],h1[0]);
        const fecha2 = new Date(d2[2],d2[1],d2[0],h2[1],h2[0]);
        if(fecha1 > fecha2){ return 1*ordenH;}  //ASCENDENTE POSITIVO, DESCENDENTE NEGATIVO
        if(fecha1 < fecha2){ return -1*ordenH;} //ASCENDENTE NEGATIVO, DESCENDENTE POSITIVO
        return 0;
      });
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },
  }
});
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  
  color: #8c8c8c;
  
  margin: 0;
}

#container a {
  text-decoration: none;
}

.cursor-pointer{
  cursor:pointer !important;
}
</style>